/* eslint-disable max-len */
import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import StatementWrapper from 'components/molecules/StatementWrapper';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { nzBankidApi, nzStavApi } from 'services/nezarazenyUcet/nuZapis';

interface IVypisUvod {}

const BankidLoginNZ: React.FC<IVypisUvod> = () => {
    const history = useHistory();
    const { idzadost } = useParams<{ idzadost: string }>(); // idzadost, sebrano z urlky pokud se v url vyskytuje pocitame s tim ze se uzivatel jiz prihlasil poprve a vraci se z odkazu na mailu.
    const [errStatus, setErrStatus] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);

    const routeChange = () => {
        let path = idzadost ? '/nezarazeny-ucet-zapis/idzadost/' + idzadost : '/nezarazeny-ucet-zapis/idzadost/';
        history.push(path);
    };

    useEffect(() => {
        if (idzadost) {
            setLoading(true);
            nzStavApi(idzadost)
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .then((resp: any) => {
                    resp.token && history.push(`/nezarazeny-ucet-zapis/token/${resp.token}`);
                })
                .catch((err: AxiosError) => {
                    setErrStatus(err.response?.status);
                })
                .finally(() => setLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idzadost]);

    const bankIdLogin = () => {
        nzBankidApi()
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((resp: any) => {
                window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID v new okne
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    const bankIdLoginZadost = () => {
        nzBankidApi(idzadost)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((resp: any) => {
                window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID v new okne
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    return (
        <>
            {errStatus ? (
                <StatementWrapper pageTitle="">
                    <Col span={24}>
                        <Row>
                            {errStatus === 400 ? (
                                <Title text="RESPONSE_ERROR_400" level={3} />
                            ) : errStatus === 401 ? (
                                <Title text="RESPONSE_ERROR_401" level={3} />
                            ) : errStatus === 404 ? (
                                <Title text="RESPONSE_ERROR_404" level={3} />
                            ) : errStatus === 500 ? (
                                <Title text="RESPONSE_ERROR_500" level={3} />
                            ) : errStatus ? (
                                <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                            ) : null}
                        </Row>

                        <Row className="statement-buttons-row">
                            <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                        </Row>
                    </Col>
                </StatementWrapper>
            ) : (
                <LoadingWrapper loading={loading}>
                    {idzadost ? (
                        <>
                            <h1>
                                <TranslateText>Přístup k žádosti o změnu údajů v nezařazené evidenci</TranslateText>
                            </h1>
                            <StatementWrapper
                                pageTitle=""
                                pageInfoText="Abyste mohli přistoupit ke dříve podané žádosti o změnu údajů v nezařazené evidenci, je nutné se nejprve identifikovat pomocí Bank iD."
                            >
                                <Row className="statement-buttons-row">
                                    <ButtonComponent
                                        buttontext="PRIHLASIT_SE_PPRES_BANKID"
                                        onClick={bankIdLoginZadost}
                                    />
                                </Row>
                            </StatementWrapper>
                        </>
                    ) : (
                        <>
                            <h1>
                                <TranslateText>POPIS_SLUZBY</TranslateText>
                            </h1>
                            <div>
                                <TranslateText>
                                    Služba umožňuje majiteli nezařazeného účtu aktualizovat osobní či adresní údaje a
                                    zapsat nebo změnit číslo bankovního účtu pro účely výplat výnosů.
                                </TranslateText>
                            </div>
                            <StatementWrapper
                                pageTitle=""
                                pageInfoText=""
                                //  pageInfoTextBold="PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE2"
                                //  pageInfoTextBold2="PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE3"
                            >
                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="PRIHLASIT_SE_PPRES_BANKID" onClick={bankIdLogin} />
                                </Row>
                            </StatementWrapper>
                        </>
                    )}
                </LoadingWrapper>
            )}
        </>
    );
};

export default BankidLoginNZ;
